<template>
    <el-container>
        <el-aside width="auto">
            <common-aside />
        </el-aside>

        <el-container>
            <!--使用小驼峰命名法  -->
            <el-header>
                <common-header />
            </el-header>
            <common-tag />
            <el-main>
                <!-- 二级路由出口 -->
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>

<!-- 样式区域 -->
<style lang="less">
.el-header {
    background-color: #333;

}
</style>

<script>
import CommonAside from '@/components/CommonAside.vue'
import CommonHeader from '@/components/CommonHeader.vue'
import CommonTag from '@/components/CommonTag.vue'
export default {
    name: 'MainPage',
    data() {
        return {

        }
    },
    components: {
        CommonAside,
        CommonHeader,
        CommonTag
    }
}
</script>